'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

let DataProtection = React.createClass({

  render : function () {

    return (
      <div  className="container" style={{ "marginTop": "5%", "marginBottom": "5%" }} >
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/footerDataProtection" />
          </h3>
          <hr className="small-blue" />

          <div className="row text-justify" >
            {
              this.props.locale == "en" ?
              <div className="row" >
                <br/>
                <div className="col-md-12">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    PERSONAL INFORMATION PRESERVATION
                  </p>
                  <p>
                    Your personal information will be preserved in accordance with the regulatory periods mentioned 
                    in the corresponding regulations for financial transactions, including those linked to the fight 
                    against money laundering, terrorist financing, and other laws that govern us. Otherwise, we will 
                    retain your information only as necessary for the specific purposes for which it was collected or 
                    to address any queries that may arise. In general, we will keep your information for a period that 
                    will not exceed the purpose(s) for which it was obtained, unless there is a legal obligation to 
                    retain it for a longer period or it is advisable to keep it in relation to a legal position of Barri 
                    Money Services (e.g., in connection with prescriptions, litigation, or regulatory investigations).
                  </p>
                  <br/>
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    ACCESS, DELETE, AND CORRECT YOUR PERSONAL INFORMATION, AND MODIFY YOUR CHOICES
                  </p>
                  <p>
                    You have the right to know if we are processing your personal information and request a copy of that 
                    information at no cost. You have the right to request a structured copy of certain information 
                    provided to us that is readable with a specific device. We may charge you a reasonable fee for 
                    providing the information, or not take any action regarding your request if the request is unfounded 
                    or considered excessive. You have the right to ask us not to send you any more marketing communications. 
                    You have the right to ask us to correct information about you if it is incomplete, inaccurate, or outdated. 
                    You have the right to ask us to delete certain information about you in order to limit certain uses of 
                    the information regarding you and also object to certain uses of it. To the extent that we process personal 
                    information based on your consent, you may withdraw it as permitted by applicable law. Registered users 
                    can log in to&nbsp;<a target='_blank' href='https://www.barrimoneytransfer.com/login'>barrimoneytransfer.com/login</a>&nbsp; 
                    and edit profile settings. You also have the right to file a complaint with a relevant data protection regulator or 
                    supervisory authority regarding the processing of your personal information. Whenever we receive a request, we may 
                    ask for additional information to verify your identity. In certain cases, we may refuse to act or impose limitations 
                    on your rights as authorized by applicable law. To exercise these rights, please contact Barri Money Services through 
                    the "CONTACT US" section. We will make every effort to respond to your request within 30 days. However, in certain 
                    cases, this period may be extended. We will comply with your request as determined by applicable law. 
                  </p>
                </div>
              </div>
              
              :

              <div className="row">
                <br/>
                <div className="col-md-12">
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    PRESERVACIÓN DE INFORMACIÓN PERSONAL
                  </p>
                  <p>
                    Su información personal será preservada de acuerdo con los períodos regulatorios mencionados en las 
                    regulaciones correspondientes para transacciones financieras, incluyendo aquellas vinculadas a la lucha 
                    contra el lavado de dinero, financiamiento del terrorismo y otras leyes que nos rigen. De lo contrario, 
                    conservaremos su información solo según sea necesario para los propósitos específicos para los cuales fue 
                    recopilada o para abordar cualquier consulta que pueda surgir. En general, mantendremos su información 
                    por un período que no excederá el(los) propósito(s) para el(los) cual(es) fue obtenida, a menos que exista 
                    una obligación legal de retenerla por un período más largo o sea aconsejable mantenerla en relación con 
                    una posición legal de Barri Money Services (por ejemplo, en relación con recetas médicas, litigios o 
                    investigaciones regulatorias).
                  </p>
                  <br/>
                  <p style={{textAlign:"left", fontWeight:"bold"}}>
                    ACCEDA, ELIMINE Y CORRIJA SU INFORMACIÓN PERSONAL, Y MODIFIQUE SUS OPCIONES
                  </p>
                  <p>
                    Usted tiene el derecho de saber si estamos procesando su información personal y de solicitar una copia de esa 
                    información sin costo alguno. Tiene el derecho de solicitar una copia estructurada de cierta información proporcionada 
                    a nosotros que sea legible con un dispositivo específico. Podemos cobrarle una tarifa razonable por proporcionar la 
                    información, o no tomar ninguna acción con respecto a su solicitud si la solicitud es infundada o se considera excesiva. 
                    Tiene el derecho de pedirnos que no le enviemos más comunicaciones de marketing. Tiene el derecho de pedirnos que 
                    corrijamos la información sobre usted si está incompleta, inexacta u obsoleta. Tiene el derecho de pedirnos que 
                    eliminemos cierta información sobre usted para limitar ciertos usos de la información con respecto a usted y también 
                    oponerse a ciertos usos de la misma. En la medida en que procesemos información personal basada en su consentimiento, 
                    puede retirarlo según lo permita la ley aplicable. Los usuarios registrados pueden iniciar sesión en&nbsp;
                    <a target='_blank' href='https://www.barrimoneytransfer.com/login'>barrimoneytransfer.com/login</a>&nbsp;y modificar la 
                    configuración del perfil. También tiene el derecho de presentar una queja ante un regulador o autoridad de protección de 
                    datos relevante con respecto al procesamiento de su información personal. Cuando recibimos una solicitud, podemos solicitar 
                    información adicional para verificar su identidad. En ciertos casos, podemos negarnos a actuar o imponer limitaciones a sus 
                    derechos según lo autorizado por la ley aplicable. Para ejercer estos derechos, comuníquese con Barri Money Services a través 
                    de la sección "CONTÁCTENOS". Haremos todo lo posible por responder a su solicitud dentro de los 30 días. Sin embargo, en casos 
                    particulares, este período puede extenderse. Cumpliremos con su solicitud según lo determine la ley aplicable.
                  </p>
                </div>
              </div>
            }
          </div>

        </div>
      </div>
    )

  }

})

module.exports = DataProtection;


// WEBPACK FOOTER //
// ./js/dataProtection.js